import React from 'react';
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";

interface SignInButtonProps {}

const SignInButton: React.FC<SignInButtonProps> = ({ }) => {
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const handleSignInClick = () => {
        setDynamicStateObj({isMenuOpen: false, visiblePopup: 'signin'});
    };

    return (
        <button
            className="mb-4 px-4 py-2 bg-cyan-600 text-white rounded"
            onClick={handleSignInClick}
        >
            Sign in
        </button>
    );
};

export default SignInButton;
